import { ReactNode, useEffect } from 'react'
import { PostHogProvider, usePostHog } from 'posthog-js/react'
import { PostHogConfig } from 'posthog-js'

const FEATURE_FLAG_POLL_INTERVAL_MS = 30000

// When featured flag is updated, only way for user to see update is with
// refreshing the page. That's why `FeatureFlagPoller` exists.
const FeatureFlagPoller = () => {
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) {
      return
    }

    const interval = setInterval(() => {
      posthog.reloadFeatureFlags()
    }, FEATURE_FLAG_POLL_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [posthog])

  return null
}

export const PostHogLoadProvider = ({ children }: { children: ReactNode }) => {
  if (
    import.meta.env.MODE === 'production' &&
    import.meta.env.VITE_PUBLIC_POSTHOG_HOST &&
    import.meta.env.VITE_PUBLIC_POSTHOG_KEY
  ) {
    return (
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={
          {
            api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
            defaults: '2025-05-24',
          } as Partial<PostHogConfig>
        }
      >
        <FeatureFlagPoller />
        {children}
      </PostHogProvider>
    )
  }

  return children
}
